/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 11.75c-6.765 0-12.25 5.483-12.25 12.25S17.235 36.25 24 36.25 36.25 30.767 36.25 24 30.765 11.75 24 11.75zm7.086 13.769a.507.507 0 0 1-.506.506h-4.555v4.618a.507.507 0 0 1-.506.507h-3.037a.507.507 0 0 1-.506-.507v-4.618H17.42a.507.507 0 0 1-.506-.506v-3.037c0-.278.227-.506.506-.506h4.555v-4.555c0-.279.228-.507.506-.507h3.037c.279 0 .506.227.506.507v4.555h4.555c.279 0 .506.228.506.506v3.037z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/add.js